module.exports = __webpack_public_path__ + "img/external-link-img.efe363ab.svg";